import React from "react";
import PropTypes from "prop-types";
import { Link, useHistory } from "react-router-dom";
import { Message } from "semantic-ui-react";
import { FormBuilder, ErrorMessage } from "@redriver/cinnamon";
import { AppRoutes, SystemRoutes } from "constants/routes";
import { signInWithMagicLink } from "./actions";

const MagicLinkSignIn = ({ token }) => {
  const history = useHistory();

  if (!token) {
    return (
      <Message negative>
        <p>
          This sign-in link is invalid or has expired. Please return to the{" "}
          <Link to={SystemRoutes.Login}>login page</Link> and request a new one.
        </p>
      </Message>
    );
  }

  return (
    <FormBuilder
      loadAction={signInWithMagicLink}
      loadParams={token}
      onLoaded={(response) => {
        if (!response) {
          return;
        }

        const { secondFactor, tokens, email } = response;
        if ((secondFactor?.availableTypes ?? []).length > 0) {
          const {
            registeredTypes,
            availableTypes,
            recoveryTypes,
            token: mfaToken,
            required,
          } = secondFactor;
          history.push(SystemRoutes.Authenticate, {
            registeredTypes,
            availableTypes,
            recoveryTypes,
            token: mfaToken,
            loginTokens: tokens,
            enforceMfa: required,
            userEmail: email,
          });
          return;
        }

        // already authenticated inside signInWithMagicLink - navigate into the app
        // explicitly rather than rely on a reactive redirect from this page's loggedIn
        // check, since the authenticated router swaps away from this public route as
        // soon as loggedIn flips, before this component gets a render to act on it
        history.replace(AppRoutes.Root);
      }}
      renderLoading={false}
      renderError={false}
      renderForm={(_formProps, { loading, slowLoading, error }) => {
        if (loading && slowLoading) {
          return <p>Signing you in...</p>;
        }

        if (!error) {
          return null;
        }

        return (
          <div>
            <ErrorMessage header="Sign In Error" error={error} omitCodes />
            <p>
              Return to <Link to={SystemRoutes.Login}>Log In</Link>
            </p>
          </div>
        );
      }}
    />
  );
};

MagicLinkSignIn.propTypes = {
  token: PropTypes.string,
};

export default MagicLinkSignIn;
